module.exports = __webpack_public_path__ + "img/icon-10-subscriptionAsset 16.65513d78.svg";